export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                placeholder: '发车单号(最多查询100单，以逗号隔开)',
                span: 4,
                unfold: true
            },
            {
                name: '司机',
                type: 'advance',
                value: 'driver',
                multiple: true,
                border: true,
                dialogWidth: '800px',
                maxSelect: 5,
                multipleTableColumn: {
                    prop: 'name', 'value': '司机名称'
                },
                advanceConfig: [
                    { 'prop': 'name', 'value': '司机名称' },
                    { 'prop': 'encuMobile', 'value': '司机电话' }
                ],
                tableConfig: [
                    { 'prop': 'name', 'value': '司机名称' },
                    { 'prop': 'encuMobile', 'value': '司机电话' }
                ],
                advanceUrl: 'suDriver/searchByConditions',
                cbParams: [
                    'name#driver', 'encuMobile#driverContactWay'
                ],
                unfold: true,
                span: 3
            },
            {
                name: '分账状态',
                value: 'divideStatus',
                type: 'select',
                optionNum: 'DIVIDE_STATUS',
                options: [],
                span: 2,
                unfold: true
            },
            {
                name: '分账支付对象',
                value: 'payObject',
                type: 'select',
                optionNum: 'PAY_OBJECT',
                options: [],
                span: 2,
                unfold: true
            },
            {
                name: '支付状态',
                value: 'payStatus',
                type: 'select',
                optionNum: 'PAY_STATUS',
                options: [],
                span: 3,
                unfold: true
            },
            {
                name: '发车时间',
                value: 'dispatchTime',
                startTime: 'startDispatchTime',
                endTime: 'endDispatchTime',
                startPlaceholder: '发车开始日期',
                endPlaceholder: '发车结束日期',
                type: 'time',
                timeNum: 6,
                span: 5,
                unfold: true
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftWidth: 80,
        selectBtn: true,
        leftOperation: true,
        columns: [
            {
                label: '分账单号',
                width: 150,
                prop: 'divideNo',
                sort: true
            },
            {
                label: '发车单号',
                width: 150,
                prop: 'dispatchNo',
                type: 'clickable',
                fixedColumn: 'left',
                sort: true
            },
            {
                label: '发车单计费成本',
                width: 150,
                prop: 'totalCostAmount',
                fixedColumn: 'left',
                sort: true
            },
            {
                label: '供应商名称',
                width: 150,
                prop: 'carrierName',
                sort: true
            },
            {
                label: '供应商编码',
                width: 150,
                prop: 'carrierCode',
                sort: true
            },
            {
                label: '司机名称',
                prop: 'driver',
                width: 150,
                sort: true
            },
            {
                label: '司机电话',
                prop: 'driverContactWay',
                width: 150,
                sort: true
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                width: 200,
                sort: true
            },
            {
                label: '分账状态',
                width: 150,
                prop: 'divideStatus',
                type: 'select',
                optionNum: 'DIVIDE_STATUS',
                options: [],
                sort: true
            },
            {
                label: '分账金额',
                width: 150,
                prop: 'divideAmount',
                sort: true
            },
            {
                label: '支付对象',
                width: 150,
                prop: 'payObject',
                type: 'select',
                optionNum: 'PAY_OBJECT',
                options: [],
                sort: true
            },
            {
                label: '支付状态',
                width: 150,
                prop: 'payStatus',
                type: 'select',
                optionNum: 'PAY_STATUS',
                options: [],
                sort: true
            },
            {
                label: '支付失败说明',
                width: 150,
                prop: 'payFailReason',
                sort: true
            },
            {
                label: '司机收款确认状态',
                width: 200,
                prop: 'confirmStatus',
                type: 'select',
                optionNum: 'DRIVER_EXPENSE_CONFIRM_STATUS',
                options: [],
                sort: true
            },
            {
                label: '发车单状态',
                sort: true,
                prop: 'dispatchStatus',
                type: 'select',
                optionNum: 'DISPATCH_STATUS',
                options: [],
                width: 120
            },
            {
                label: '发车时间',
                width: 150,
                prop: 'dispatchTime',
                sort: true
            },
            {
                label: '抵达时间',
                width: 150,
                prop: 'arrivalTime',
                sort: true
            },
            {
                label: '创建时间',
                width: 150,
                prop: 'createTime',
                sort: true
            },
            {
                label: '编辑时间',
                width: 150,
                prop: 'updateTime',
                sort: true
            },
            {
                label: '编辑用户',
                width: 150,
                prop: 'updateUserName',
                sort: true
            }
        ],
        action: [
            {
                type: 'text',
                label: '调整',
                size: 'mini',
                event: 'adjust',
                ifHas: 'driver-expense-split-adjust'
            }
            // {
            //     type: 'text',
            //     label: '匹配支付订单',
            //     size: 'mini',
            //     event: 'matchPaymentOrder',
            //     ifHas: ''
            // }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 50, 100]
    },
    searchTotalTitle: [
        // {
        //     name: '供应商',
        //     advanceLabel: '供应商',
        //     value: 'carrierName',
        //     advanceConfig: [
        //         { prop: 'supplierNameCn', value: '供应商名称' },
        //         { prop: 'supplierCode', value: '供应商编码' }
        //     ],
        //     tableConfig: [
        //         { prop: 'supplierNameCn', value: '供应商名称' },
        //         { prop: 'supplierCode', value: '供应商编码' },
        //         { prop: 'transNameListStr', value: '采购渠道' }
        //     ],
        //     method: 'post',
        //     prefix: '/api-tms',
        //     advanceUrl: '/srm/supplier/search',
        //     type: 'advance',
        //     advanceNotSearch: true,
        //     queryConditionRequired: true,
        //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode'],
        //     advanceCascade: 'supplierCode#carrierCode'
        // },
        {
            name: '司机收款确认状态',
            value: 'confirmStatus',
            type: 'select',
            optionNum: 'DRIVER_EXPENSE_CONFIRM_STATUS',
            options: []
        }
    ]
};
